import dayjs from 'dayjs'
import { booking } from '@/api/booking'
import { invoice } from '@/api/invoice'
import { config } from '@/api/config-setting'
import { commonServices } from '@/api/common-services'
import 'devextreme/dist/css/dx.light.css'
import { Workbook } from 'exceljs'
import { exportDataGrid } from 'devextreme/excel_exporter'
import { saveAs } from 'file-saver-es'
import { convertUTC } from '@/@core/utils/utils'
import ExcelJS from "exceljs";
import ConfirmDialog from '@core/components/confirm-dialog/ConfirmDialog.vue'
import DeleteDialog from '@core/components/delete-dialog/DeleteDialog.vue'
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxFilterRow,
  DxHeaderFilter,
  DxGroupPanel,
  DxGrouping,
  DxScrolling,
  DxPaging,
  DxPager,
  DxSummary,
  DxLookup,
  DxTotalItem,
  DxGroupItem,
  DxMasterDetail,
  DxStringLengthRule,
  DxRequiredRule,
  DxRangeRule,
  DxValueFormat,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
} from 'devextreme-vue/data-grid'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import Treeselect from '@riophae/vue-treeselect'
const dataGridRef = 'dataGrid'
export default {
  name: 'EzPaymentConfig',
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxFilterRow,
    DxHeaderFilter,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxPaging,
    DxPager,
    DxSummary,
    DxLookup,
    DxTotalItem,
    DxGroupItem,
    DxMasterDetail,
    DxStringLengthRule,
    DxRangeRule,
    DxRequiredRule,
    DxValueFormat,
    DxColumnChooser,
    DxColumnFixing,
    DxSelection,
    DxExport,
    Treeselect,
    'confirm-dialog': ConfirmDialog,
    'delete-dialog': DeleteDialog,
  },
  data() {
    return {
      dataGridRef,
      search: {
        ClientId: [],
        KeyWord: '',

        BDC: [],
        FromDate: this.getUTC('start', 'day'),
        ToDate: this.getUTC('start', 'day'),
        PaymentCode: null,
        InvoiceNo: null,
        Page:1,
        PageSize:50,
        Type:'',
        PaymentMethod:null

      },
            ezPaymentConfigDetail : {
            Id: null,
            PaymentGetWayCode: '',
            ConnectId: '',
            ConnectKey: '',
            PaymentTypeCode: '',
            PaymentMethodId: '',
            TransactionCode: '',
            PaymentTypeName: '',
            PaymentMethodName: '',
            Description: '',
        },
        ezPaymentConfigDetailDefault :null,   
        showAddNew: false,
      listConfigEzPayment: [],
      currentPage: 1,
      totalRow: 0,
      perPage: 100,
      allMode: 'allPages',
      checkBoxesMode: 'onClick', // 'always' :
      optionPerPage: [100, 250, 500],
      selectedGolfClass : null,
      optionType:[],
      optionPaymentMethod:[],
      configTable: [
        {
          caption: this.$t('golf_common_payment_getway_code'),
          field: 'PaymentGetWayCode',
          isShow: true,
          alignment: 'left',
        },
        {
          caption: 'ConnectId',
          field: 'ConnectId',
          isShow: true,
          alignment: 'left',
        },
        {
          caption: 'ConnectKey',
          field: 'ConnectKey',
          isShow: true,
          alignment: 'left',
        },
        {
          caption: this.$t('golf_payment_payment_type'), // golf_payment_payment_type
          field: 'PaymentTypeName',
          isShow: true,
          alignment: 'left',
        },
        {
          caption: this.$t('golf_payment_payment_method'),
          field: 'PaymentMethodName',
          isShow: true,
          alignment: 'left',
        },
        {
          caption: 'TransactionCode',
          field: 'Description',
          isShow: true,
          alignment: 'left',
        }
        // {
        //   caption: '',
        //   field: 'action',
        //   isShow: true,
        //   cellTemplate: 'action',
        //   alignment: 'center',
        // },
      ],
      isLoading: false,
      selectedRowsData: [],
      paymentDataSelected: [],
      listClient: [],
      listCashiers: [],
      zoneId: null,
      listPaymentType: [],
      ShowPaymentType: false,
      paymentTypeOptions: [],
      listPaymentMethodEInvocie: [],
      checkModuleEInvocie: JSON.parse(localStorage.getItem('module')).find(x => x == "EINVOICE"),
      columnWidths :[],
      TotalAmount :0,
      TotalAmountNotOfEInvoice :0,
      TotalAmountOfEInvoice :0,
      listPaymentMethodByRoomId :[],
      isShowPaymentByRoom : true,
      isProcessing : false,
    }
  },
  computed: {
    dataGrid() {
      return this.$refs[dataGridRef].instance
    },
     totalPages() {
    return Math.ceil(this.totalRow / this.perPage);
  },
  startRecord() {
    return (this.currentPage - 1) * this.perPage + 1;
  },
  endRecord() {
    return Math.min(this.currentPage * this.perPage, this.totalRow);
  }
  },
  created() {
    this.call_api_RPF02()
    this.getListEzPaymentConfig()
    this.getConfigInfo_RCOM01()
  },
  watch: {
    
 },
 mounted() {
  // Gán mặc định phần tử đầu tiên
  },
  methods: {
    _dayjs: dayjs,
   async getListEzPaymentConfig() {
      this.isLoading = true
      const response = await config.API_EzPayment_RCEP01()
      this.isLoading = false
      if (response.Status === '200') {
       this.listConfigEzPayment = response.Data.ConfigEzPayments
       this.ezPaymentConfigDetailDefault = null
      }
    },
    openSidebarAddEzPaymentConfig() {
        this.$root.$emit('bv::toggle::collapse', 'add-new-ezpayment-config')
       this.ShowPaymentType = false
        this.ezPaymentConfigDetail = {
            Id: null,
            PaymentGetWayCode: this.optionType && this.optionType.length > 0 ? this.optionType[0].value : '',
            ConnectId: '',
            ConnectKey: '',
            PaymentTypeCode: '',
            PaymentMethodId: '',
            TransactionCode: '',
            PaymentTypeName: '',
            PaymentMethodName: '',
            Description: '',
            IsDeleted: false
        }
    },
    openSidebarUpdateEzPaymentConfig(){
        if (this.ezPaymentConfigDetailDefault === null) {
            this.showToast('error', this.$t('golf_common_please_select_config_ezp'))
            return
          }
        this.ezPaymentConfigDetail = this.ezPaymentConfigDetailDefault
        this.ShowPaymentType = false
        this.$root.$emit('bv::toggle::collapse', 'add-new-ezpayment-config')
    },
     configInvoice_onRowClick(item) {
        if(item.rowType === 'data') {
            this.ezPaymentConfigDetailDefault = {
            Id: item.data.Id,
            PaymentGetWayCode: item.data.PaymentGetWayCode,
            ConnectId: item.data.ConnectId,
            ConnectKey: item.data.ConnectKey,
            PaymentTypeCode: item.data.PaymentTypeCode,
            PaymentMethodId: item.data.PaymentMethodId,
            TransactionCode:  item.data.TransactionCode,
            PaymentTypeName: item.data.PaymentTypeName,
            PaymentMethodName: item.data.PaymentMethodName,
            Description: item.data.Description,
        }
        }
    },
    AddEzPaymentConfig() {
      if (this.isProcessing) {
        return; // Ngăn chặn nếu đang xử lý
      }

      if (this.ezPaymentConfigDetail.PaymentGetWayCode === '') {
        this.showToast('error', this.$t('golf_common_payment_getway_code_required'))
        return
      }
      if (this.ezPaymentConfigDetail.ConnectId === '') {
        this.showToast('error', this.$t('golf_common_connect_id_required'))
        return
      }
      if (this.ezPaymentConfigDetail.ConnectKey === '') {
        this.showToast('error', this.$t('golf_common_connect_key_required'))
        return
      }
      if (this.ezPaymentConfigDetail.PaymentTypeCode === '') {
        this.showToast('error', this.$t('golf_payment_payment_type_required'))
        return
      }
      if (this.ezPaymentConfigDetail.PaymentMethodId === null) {
        this.showToast('error', this.$t('golf_payment_payment_method_required'))
        return
      }
      if (this.ezPaymentConfigDetail.TransactionCode === '') {
        this.showToast('error', this.$t('golf_common_transaction_code_required'))
        return
      }
      this.isLoading = true
      this.isProcessing = true
      const body = {
        ConfigEzPayment: this.ezPaymentConfigDetail,
      }
      config.API_EzPayment_UCEP01(body)
        .then(response => {
          if (response.Status === '200') {
            this.isProcessing = false
            this.getListEzPaymentConfig()
            this.$root.$emit('bv::toggle::collapse', 'add-new-ezpayment-config')
            this.showResToast(response)
          }
        })
      this.isLoading = false
      this.isProcessing = false
    },
    async confimDeleteEzPaymentConfig(){
    if (this.ezPaymentConfigDetailDefault === null) {
            this.showToast('error', this.$t('golf_common_please_select_config_ezp'))
            return
    }
        this.$refs.confirmDialogComponent.open()
    },
    async deleteConfigEzPayment() {
      this.isLoading = true
      const body = {
        ConfigEzPayment:{
            Id: this.ezPaymentConfigDetailDefault.Id,
            PaymentGetWayCode: this.ezPaymentConfigDetailDefault.PaymentGetWayCode,
            ConnectId: this.ezPaymentConfigDetailDefault.ConnectId,
            ConnectKey: this.ezPaymentConfigDetailDefault.ConnectKey,
            PaymentTypeCode: this.ezPaymentConfigDetailDefault.PaymentTypeCode,
            PaymentMethodId: this.ezPaymentConfigDetailDefault.PaymentMethodId,
            TransactionCode: this.ezPaymentConfigDetailDefault.TransactionCode,
            //PaymentTypeName: this.ezPaymentConfigDetailDefault.PaymentTypeName,
            //PaymentMethodName: this.ezPaymentConfigDetailDefault.PaymentMethodName,
            //Description: this.ezPaymentConfigDetailDefault.Description,
            IsDeleted: true
        }
      }
      config.API_EzPayment_UCEP01(body)
        .then(response => {
          if (response.Status === '200') {
            this.getListEzPaymentConfig()
            this.showResToast(response)
          }
        })
      this.isLoading = false
    },
    handleChoicePayment(item, payment, trans) {

      // this.form.PaymentTypeCode = item
       this.ezPaymentConfigDetail.PaymentTypeCode = item.Code
       this.ezPaymentConfigDetail.PaymentTypeName = item.Name
       this.ezPaymentConfigDetail.PaymentMethodId = payment.Id
       this.ezPaymentConfigDetail.PaymentMethodName = payment.Name
       this.ezPaymentConfigDetail.TransactionCode = trans.TransactionCode
       this.ezPaymentConfigDetail.Description = `${trans.TransactionCode} - ${trans.Description}`
      // this.ezPaymentConfigDetail.PaymentTypeCode = payment.Code
      // this.paymentTypeName = `${payment.Name} - ${trans.Description}`
      // this.TransactionCode = trans.TransactionCode
      // this.form.PaymentMethodId = payment.Id
      // this.canShowPaymentType = false
       this.ShowPaymentType = false
    },
     async call_api_RPF02() {
      await booking.api_RPF02({
        ZoneId: JSON.parse(localStorage.getItem('userGolfData')).BarLocation.map(item => String(item.Id)),
      }).then(async response => {
        if (response.Status === '200') {
          this.listPaymentType = response?.Data?.PaymentType
          // this.paymentTypeOptions = response?.Data?.PaymentType.map(x => ({
          //   title: x.Name,
          //   value: x.Code,
          // }))
        }
      })
    },
    handlePaymentType()
    {
      this.ShowPaymentType = !this.ShowPaymentType
    },
    async getConfigInfo_RCOM01() {
      const response = await booking.getConfigInfo({ KeyGroup: 'PAYMENT_CONFIG' })
      if (response.Status === '200') {
        const listPaymentGetWayCode = response?.Data.filter(item => item.KeyCode === 'PAYMENT_CONFIG_GETWAY_CODE_EZPAYMENT')
        console.log(listPaymentGetWayCode)
        if(listPaymentGetWayCode !== null && listPaymentGetWayCode.length >  0 ) {

          this.optionType = listPaymentGetWayCode[0].KeyValue.split(',').map(item => {
  return {
    label: item.trim(),
    value: item.trim()
  };
});
          
        }
      }
    },
  }
  


}
